import { jsxs, jsx } from 'react/jsx-runtime';
import styles from '../styles/footer.module.scss.js';
import PromptInput from '@amzn/awsui-components-react/polaris/prompt-input';
import { useRef, useEffect } from 'react';

const ChatBotFooter = ({ userInput, onInputChange, onEnterPress, isMaximized, disabled }) => {
    const handleInputChange = ({ detail }) => {
        if (detail.value.length < 1000) {
            onInputChange(detail.value);
        }
    };
    const ref = useRef(null);
    // This code will auto focus on input field when open the bot
    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, [ref]);
    return (jsxs("div", { className: `${styles['chatbot-footer']} ${isMaximized ? styles['maximized-width'] : ''}`, children: [jsx(PromptInput, { onChange: handleInputChange, value: userInput, "data-testid": 'chatbotInput', actionButtonIconName: 'send', placeholder: 'Ask me a question. Max 1000 characters', actionButtonAriaLabel: 'Send message', ariaLabel: 'Message input', onAction: onEnterPress, disabled: disabled, ref: ref }), jsxs("div", { className: styles['footer-text'], children: [jsxs("div", { className: styles['first-line'], children: [jsx("p", { children: jsx("a", { href: 'https://amazonmr.au1.qualtrics.com/jfe/form/SV_9S3a8q7dsyD3q62', rel: 'noreferrer', target: '_blank', className: styles['link-text'], children: "Share your feedback" }) }), jsx("div", { className: styles['separator'], "aria-hidden": 'true' }), jsxs("p", { children: ["Use is subject to", ' ', jsx("a", { href: 'https://aws.amazon.com/machine-learning/responsible-ai/policy/', rel: 'noreferrer', target: '_blank', className: styles['link-text'], children: "AWS Responsible AI Policy" })] })] }), jsx("p", { children: "Do not include personal or sensitive information." })] })] }));
};

export { ChatBotFooter as default };
